// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import BannerController from "./banner_controller";
application.register("banner", BannerController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import DisclosureController from "./disclosure_controller";
application.register("disclosure", DisclosureController);

import FlagCarouselController from "./flag_carousel_controller";
application.register("flag-carousel", FlagCarouselController);

import HeadersController from "./headers_controller";
application.register("headers", HeadersController);

import HotkeysController from "./hotkeys_controller";
application.register("hotkeys", HotkeysController);

import MobileConsoleController from "./mobile_console_controller";
application.register("mobile-console", MobileConsoleController);

import MoneyController from "./money_controller";
application.register("money", MoneyController);

import PasskeyEnrollController from "./passkey_enroll_controller";
application.register("passkey-enroll", PasskeyEnrollController);

import PasskeySignInController from "./passkey_sign_in_controller";
application.register("passkey-sign-in", PasskeySignInController);

import PercentageController from "./percentage_controller";
application.register("percentage", PercentageController);

import ScrollRestoreController from "./scroll_restore_controller";
application.register("scroll-restore", ScrollRestoreController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import SubmitController from "./submit_controller";
application.register("submit", SubmitController);

// ViewComponent controllers
import AppToastComponentController from "../../components/app/toast_component_controller";
application.register("toast", AppToastComponentController);
